/**
 * @class SequentialTextBanner
 * @description A custom element that animates a banner's text content.
 * @requires GSAP & GSAP SplitText Plugin
 */
if (!customElements.get('sequential-text-banner')) {
  class SequentialTextBanner extends HTMLElement {
    constructor() {
      super();
      this.tl = null;
      this.splittext = null;
    }
    connectedCallback() {
      if (typeof gsap !== 'undefined') {
        this.prepareAnimations();
      } else {
        console.warn('GSAP or SplitText is not loaded. Animations for SequentialTextBanner will not run.');
      }
    }
    disconnectedCallback() {
      if (this.tl) this.tl.kill();
      if (this.splittext) this.splittext.revert();
    }
    prepareAnimations() {
      const section = this;
      let timing_offset = 0;
      section.tl = gsap.timeline();

      document.fonts.ready.then(() => {
        section.splittext = new SplitText(section.querySelectorAll('.banner-heading, .banner-text p'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        const subheading = section.querySelector('.banner-subheading');
        if (subheading) {
          section.tl.from(subheading, { duration: 0.8, opacity: 0 }, 0);
          timing_offset = 0.5;
        }

        const heading = section.querySelector('.banner-heading');
        if (heading) {
          const headingLines = section.querySelectorAll('.banner-heading .line-child div');
          const h_duration = 0.8 + ((headingLines.length - 1) * 0.08);
          section.tl
            .set(heading, { visibility: 'visible' }, 0)
            .from(headingLines, { duration: h_duration, yPercent: 105, stagger: 0.08 }, 0);
          timing_offset = Math.max(timing_offset, h_duration);
        }

        const paragraph = section.querySelector('.banner-text p');
        if (paragraph) {
          const paragraphLines = section.querySelectorAll('.banner-text p .line-child div');
          const p_duration = 0.8 + ((paragraphLines.length - 1) * 0.02);
          section.tl
            .set(paragraph, { visibility: 'visible' }, 0)
            .from(paragraphLines, { duration: p_duration, yPercent: 105, stagger: 0.02 }, 0);
          timing_offset = Math.max(timing_offset, p_duration);
        }

        const buttons = section.querySelectorAll('.button');
        if (buttons.length > 0) {
          const button_start_time = timing_offset * 0.4;
          section.tl.from(buttons, { duration: 0.5, autoAlpha: 0, y: 10, stagger: 0.1 }, button_start_time);
        }
      });
    }
  }
  customElements.define('sequential-text-banner', SequentialTextBanner);
}